<svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="150" height="150" fill="white"/>
<path d="M107 55V51H113.5V60H115.5V51H121.5V60H123.5V51H129.5V60H131.5V51H140.199L134.769 56.8177L136.231 58.1823L142.446 51.5235C143.341 50.5646 142.661 49 141.349 49H106.5C105.672 49 105 49.6716 105 50.5V55H107Z" fill="url(#paint0_linear_15481_6038)"/>
<path d="M19.0001 74C19.0001 73.4477 19.4478 73 20.0001 73H21.0001C21.5523 73 22.0001 73.4477 22.0001 74V80H19.0001V74Z" fill="url(#paint1_linear_15481_6038)"/>
<g filter="url(#filter0_i_15481_6038)">
<path d="M52.1815 50.6369C53.0422 48.9154 54.3815 47.4789 56.0385 46.4997L74.0925 35.8314C74.9115 35.3475 75.958 35.5074 76.5951 36.2138L98.5001 60.4997L44.5001 65.9997L52.1815 50.6369Z" fill="url(#paint2_linear_15481_6038)"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M41.085 68.358L102.628 62.0897L78.0804 34.8743C76.8061 33.4615 74.7131 33.1418 73.0752 34.1097L55.0211 44.778C53.0327 45.9529 51.4256 47.6767 50.3927 49.7425L41.085 68.358ZM56.0386 46.4998C54.3816 47.479 53.0423 48.9155 52.1816 50.6369L44.5002 65.9998L98.5002 60.4998L76.5952 36.2138C75.9581 35.5075 74.9116 35.3476 74.0926 35.8315L60.0456 44.132L68.3576 57.9854L66.6426 59.0143L58.3237 45.1495L56.0386 46.4998Z" fill="url(#paint3_linear_15481_6038)"/>
<path d="M14.7048 79.4592C14.8888 79.173 15.2057 79 15.546 79H55V93H7.83171C7.04055 93 6.56271 92.1248 6.99054 91.4592L14.7048 79.4592Z" fill="url(#paint4_linear_15481_6038)"/>
<g filter="url(#filter1_i_15481_6038)">
<path d="M41.6857 55.447C41.871 55.1678 42.1838 55 42.5189 55H146.734C147.603 55 148.058 56.0322 147.472 56.6741L143.524 61H38L41.6857 55.447Z" fill="url(#paint5_linear_15481_6038)"/>
</g>
<path d="M36.2081 60.4817C36.3893 60.1827 36.7136 60 37.0633 60H146.686C147.562 60 148.015 61.0471 147.414 61.6853L132.752 77.2657C123.303 87.3066 110.127 93 96.3398 93H16.5L36.2081 60.4817Z" fill="url(#paint6_linear_15481_6038)"/>
<g filter="url(#filter2_i_15481_6038)">
<circle cx="35.0001" cy="85" r="3" fill="url(#paint7_linear_15481_6038)"/>
</g>
<g filter="url(#filter3_i_15481_6038)">
<circle cx="16.5001" cy="85.5" r="1.5" fill="url(#paint8_linear_15481_6038)"/>
</g>
<g filter="url(#filter4_i_15481_6038)">
<circle cx="45.0001" cy="85" r="3" fill="url(#paint9_linear_15481_6038)"/>
</g>
<g filter="url(#filter5_i_15481_6038)">
<path d="M37.8515 66.2222C37.9442 66.0831 38.1003 65.9995 38.2675 65.9995H112.646C114.229 65.9995 114.732 68.1333 113.317 68.8412C113.108 68.9453 112.879 68.9995 112.646 68.9995H36.9342C36.5348 68.9995 36.2966 68.5544 36.5182 68.2222L37.8515 66.2222Z" fill="url(#paint10_linear_15481_6038)"/>
</g>
<g filter="url(#filter6_i_15481_6038)">
<path d="M34.2266 71.2352C34.318 71.0889 34.4783 71 34.6507 71H85.3913C86.8436 71 87.4483 72.8578 86.2742 73.7126C86.0177 73.8994 85.7086 74 85.3913 74H33.4017C33.0091 74 32.7697 73.5682 32.9776 73.2352L34.2266 71.2352Z" fill="url(#paint11_linear_15481_6038)"/>
</g>
<g opacity="0.2">
<path d="M94.4363 93L116.376 55H146.734C147.603 55 148.058 56.0322 147.472 56.6741L144.437 60H146.686C147.562 60 148.015 61.0471 147.414 61.6853L132.752 77.2657C123.303 87.3066 110.127 93 96.3398 93H94.4363Z" fill="url(#paint12_linear_15481_6038)" fill-opacity="0.4"/>
</g>
<g opacity="0.2">
<path d="M107.115 91.8255L128.376 55H146.734C147.603 55 148.058 56.0322 147.472 56.6741L144.437 60H146.686C147.562 60 148.015 61.0471 147.414 61.6853L132.752 77.2657C125.807 84.6457 116.849 89.6771 107.115 91.8255Z" fill="url(#paint13_linear_15481_6038)" fill-opacity="0.4"/>
</g>
<path d="M145 105C144.116 105 143.4 104.304 143.4 103.444V101.111H134.6C133.716 101.111 133 100.415 133 99.5556C133 98.6964 133.716 98 134.6 98H147.4C148.284 98 149 98.6964 149 99.5556C149 100.415 148.284 101.111 147.4 101.111H146.6V103.444C146.6 104.304 145.884 105 145 105Z" fill="url(#paint14_linear_15481_6038)"/>
<path d="M12 93H16V98H12V93Z" fill="url(#paint15_linear_15481_6038)"/>
<path d="M114 90H118V98H114V90Z" fill="url(#paint16_linear_15481_6038)"/>
<path d="M6.54415 89.3675C6.81638 88.5509 7.58065 88 8.44152 88H26.5585C27.4193 88 28.1836 88.5509 28.4558 89.3675L29.1225 91.3675C29.5542 92.6626 28.5903 94 27.2251 94H7.77485C6.40973 94 5.44579 92.6626 5.87748 91.3675L6.54415 89.3675Z" fill="url(#paint17_linear_15481_6038)"/>
<path d="M103.919 90.0993C103.895 89.2388 104.425 88.4598 105.234 88.1653L121.686 82.1774C122.495 81.8829 123.401 82.1392 123.936 82.8135L125.247 84.4649C126.095 85.5342 125.647 87.1206 124.364 87.5875L106.66 94.0315C105.377 94.4984 104.014 93.5713 103.976 92.2067L103.919 90.0993Z" fill="url(#paint18_linear_15481_6038)"/>
<path d="M128.317 76.1957C127.731 75.6099 126.782 75.6099 126.196 76.1957C125.61 76.7815 125.61 77.7312 126.196 78.317L132.201 84.3222L115.691 100.833L118.519 103.661L143.352 78.8282L140.524 75.9998L134.322 82.2009L128.317 76.1957Z" fill="url(#paint19_linear_15481_6038)"/>
<path d="M140.523 76L143.352 78.8284L141.935 80.2455L139.106 77.4171L140.523 76Z" fill="url(#paint20_linear_15481_6038)"/>
<circle cx="133" cy="79" r="2" fill="url(#paint21_linear_15481_6038)"/>
<circle cx="133" cy="79" r="1" fill="url(#paint22_linear_15481_6038)"/>
<circle cx="127" cy="77" r="3" fill="url(#paint23_linear_15481_6038)"/>
<circle cx="127" cy="77" r="2" fill="url(#paint24_linear_15481_6038)"/>
<path d="M41.4046 88H67.5954C77.6246 88 86.4156 93.1995 91.3192 101H96C90.7002 90.9045 79.9699 84 67.5954 84H41.4046C29.0301 84 18.2998 90.9045 13 101H17.6808C22.5844 93.1995 31.3754 88 41.4046 88Z" fill="url(#paint25_linear_15481_6038)"/>
<path d="M1 100.6C1 99.7163 1.29848 99 1.66667 99H2.33333C2.70152 99 3 99.7163 3 100.6V105.4C3 106.284 2.70152 107 2.33333 107H1.66667C1.29848 107 1 106.284 1 105.4V100.6Z" fill="url(#paint26_linear_15481_6038)"/>
<path d="M5.75792 99.2541C5.58862 99.0882 5.39161 99 5.19034 99L2 99.0001V107H4.88041C5.30887 107 5.69432 106.603 5.85419 105.997L6.92408 101.942C7.11201 101.229 6.94153 100.414 6.51787 99.9988L5.75792 99.2541Z" fill="url(#paint27_linear_15481_6038)"/>
<path d="M5 99C5 98.4477 5.44772 98 6 98H142.901C142.956 98 143 98.0443 143 98.099C143 103.567 138.567 108 133.099 108H6C5.44772 108 5 107.552 5 107V99Z" fill="url(#paint28_linear_15481_6038)"/>
<path d="M124 101C125.105 101 126 101.895 126 103C126 104.105 125.105 105 124 105L83 105C81.8954 105 81 104.105 81 103C81 101.895 81.8954 101 83 101L124 101Z" fill="url(#paint29_linear_15481_6038)"/>
<path d="M33 98H75L84 108H26L33 98Z" fill="url(#paint30_linear_15481_6038)"/>
<path d="M53 114C53 107.373 47.6274 102 41 102C34.3726 102 29 107.373 29 114C29 120.627 34.3726 126 41 126C47.6274 126 53 120.627 53 114Z" fill="url(#paint31_linear_15481_6038)"/>
<g filter="url(#filter7_i_15481_6038)">
<path d="M47.3067 114C47.3067 117.483 44.483 120.307 40.9998 120.307C37.5166 120.307 34.6929 117.483 34.6929 114C34.6929 110.517 37.5166 107.693 40.9998 107.693C44.483 107.693 47.3067 110.517 47.3067 114Z" fill="url(#paint32_linear_15481_6038)"/>
</g>
<path d="M45.4553 118.438L36.5615 109.544C37.7003 108.401 39.2764 107.693 41.0178 107.693C44.491 107.693 47.3067 110.508 47.3067 113.982C47.3067 115.723 46.5989 117.299 45.4553 118.438Z" fill="url(#paint33_linear_15481_6038)" fill-opacity="0.4"/>
<g filter="url(#filter8_i_15481_6038)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M41 108.386C37.8996 108.386 35.3861 110.9 35.3861 114C35.3861 117.1 37.8996 119.614 41 119.614C44.1005 119.614 46.6139 117.1 46.6139 114C46.6139 110.9 44.1005 108.386 41 108.386ZM34 114C34 110.134 37.134 107 41 107C44.866 107 48 110.134 48 114C48 117.866 44.866 121 41 121C37.134 121 34 117.866 34 114Z" fill="#01040B"/>
</g>
<path d="M79 114C79 107.373 73.6274 102 67 102C60.3726 102 55 107.373 55 114C55 120.627 60.3726 126 67 126C73.6274 126 79 120.627 79 114Z" fill="url(#paint34_linear_15481_6038)"/>
<g filter="url(#filter9_i_15481_6038)">
<path d="M73.3067 114C73.3067 117.483 70.483 120.307 66.9998 120.307C63.5166 120.307 60.6929 117.483 60.6929 114C60.6929 110.517 63.5166 107.693 66.9998 107.693C70.483 107.693 73.3067 110.517 73.3067 114Z" fill="url(#paint35_linear_15481_6038)"/>
</g>
<path d="M71.277 118L63 109.723C64.0598 108.659 65.5266 108 67.1472 108C70.3796 108 73 110.62 73 113.853C73 115.473 72.3413 116.94 71.277 118Z" fill="url(#paint36_linear_15481_6038)" fill-opacity="0.4"/>
<g filter="url(#filter10_i_15481_6038)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M67 108.386C63.8996 108.386 61.3861 110.9 61.3861 114C61.3861 117.1 63.8996 119.614 67 119.614C70.1005 119.614 72.6139 117.1 72.6139 114C72.6139 110.9 70.1005 108.386 67 108.386ZM60 114C60 110.134 63.134 107 67 107C70.866 107 74 110.134 74 114C74 117.866 70.866 121 67 121C63.134 121 60 117.866 60 114Z" fill="#01040B"/>
</g>
<path d="M125 121C125 118.239 122.761 116 120 116C117.239 116 115 118.239 115 121C115 123.761 117.239 126 120 126C122.761 126 125 123.761 125 121Z" fill="url(#paint37_linear_15481_6038)"/>
<g filter="url(#filter11_i_15481_6038)">
<path d="M122.628 121C122.628 122.451 121.451 123.628 120 123.628C118.548 123.628 117.372 122.451 117.372 121C117.372 119.549 118.548 118.372 120 118.372C121.451 118.372 122.628 119.549 122.628 121Z" fill="url(#paint38_linear_15481_6038)"/>
</g>
<g filter="url(#filter12_i_15481_6038)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M120 118.661C118.708 118.661 117.661 119.708 117.661 121C117.661 122.292 118.708 123.339 120 123.339C121.292 123.339 122.339 122.292 122.339 121C122.339 119.708 121.292 118.661 120 118.661ZM117.083 121C117.083 119.389 118.389 118.083 120 118.083C121.611 118.083 122.917 119.389 122.917 121C122.917 122.611 121.611 123.917 120 123.917C118.389 123.917 117.083 122.611 117.083 121Z" fill="#01040B"/>
</g>
<path d="M118.714 116H121.278C122.55 116 123.67 116.652 124.322 117.641C124.543 117.976 124.895 118.224 125.297 118.224H125.449C126.103 118.224 126.581 117.6 126.276 117.021C125.332 115.225 123.448 114 121.278 114H118.714C116.544 114 114.66 115.225 113.715 117.021C113.411 117.6 113.888 118.224 114.542 118.224H114.695C115.096 118.224 115.448 117.976 115.669 117.641C116.321 116.652 117.442 116 118.714 116Z" fill="url(#paint39_linear_15481_6038)"/>
<path d="M118 108H122V120C122 121.105 121.105 122 120 122C118.895 122 118 121.105 118 120V108Z" fill="url(#paint40_linear_15481_6038)"/>
<path d="M41.9089 99H67.0911C73.6098 99 79.1598 103.166 81.2461 108.992C81.7707 110.457 82.9567 111.662 84.4366 111.94C84.5256 111.978 84.6239 112 84.7273 112H88C90.2091 112 92 110.209 92 108H88.2484C85.6107 98.761 77.137 92 67.0911 92H41.9089C31.863 92 23.3893 98.761 20.7516 108H17C17 110.209 18.7909 112 21 112H24.2727C24.3761 112 24.4744 111.978 24.5634 111.94C26.0433 111.662 27.2293 110.457 27.7539 108.992C29.8402 103.166 35.3902 99 41.9089 99Z" fill="url(#paint41_linear_15481_6038)"/>
<defs>
<filter id="filter0_i_15481_6038" x="44.5001" y="34.5532" width="55" height="31.4463" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter1_i_15481_6038" x="38" y="54" width="110.735" height="7" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter2_i_15481_6038" x="32.0001" y="81" width="7" height="7" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter3_i_15481_6038" x="15.0001" y="83" width="4" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter4_i_15481_6038" x="42.0001" y="81" width="7" height="7" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter5_i_15481_6038" x="36.4333" y="64.9995" width="78.7147" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter6_i_15481_6038" x="32.9009" y="70" width="54.9932" height="4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter7_i_15481_6038" x="34.6929" y="106.693" width="13.6139" height="13.6138" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter8_i_15481_6038" x="34" y="105" width="16" height="16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="4" dy="-2"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter9_i_15481_6038" x="60.6929" y="106.693" width="13.6139" height="13.6138" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter10_i_15481_6038" x="60" y="105" width="16" height="16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="4" dy="-2"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter11_i_15481_6038" x="117.372" y="117.372" width="6.2558" height="6.25586" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<filter id="filter12_i_15481_6038" x="117.083" y="116.083" width="7.83331" height="7.8335" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="4" dy="-2"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_15481_6038"/>
</filter>
<linearGradient id="paint0_linear_15481_6038" x1="105" y1="60" x2="138.059" y2="40.763" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint1_linear_15481_6038" x1="19.0001" y1="80" x2="22.489" y2="79.7471" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint2_linear_15481_6038" x1="44.5001" y1="65.9997" x2="102.421" y2="48.6281" gradientUnits="userSpaceOnUse">
<stop stop-color="#D5D9E0"/>
<stop offset="1" stop-color="#F8F8FA"/>
</linearGradient>
<linearGradient id="paint3_linear_15481_6038" x1="41.085" y1="68.358" x2="107.13" y2="48.6101" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint4_linear_15481_6038" x1="6.83008" y1="93" x2="52.1543" y2="72.659" gradientUnits="userSpaceOnUse">
<stop stop-color="#0B2B65"/>
<stop offset="1" stop-color="#2366B0"/>
</linearGradient>
<linearGradient id="paint5_linear_15481_6038" x1="38" y1="61" x2="56.54" y2="16.7718" gradientUnits="userSpaceOnUse">
<stop stop-color="#0B2B65"/>
<stop offset="1" stop-color="#2366B0"/>
</linearGradient>
<linearGradient id="paint6_linear_15481_6038" x1="16.5" y1="93" x2="133.375" y2="32.397" gradientUnits="userSpaceOnUse">
<stop stop-color="#0B2B65"/>
<stop offset="1" stop-color="#2366B0"/>
</linearGradient>
<linearGradient id="paint7_linear_15481_6038" x1="32.0001" y1="88" x2="38.6692" y2="87.1301" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint8_linear_15481_6038" x1="15.0001" y1="87" x2="18.3346" y2="86.5651" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint9_linear_15481_6038" x1="42.0001" y1="88" x2="48.6692" y2="87.1301" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint10_linear_15481_6038" x1="36.4333" y1="68.9995" x2="43.5085" y2="45.0934" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint11_linear_15481_6038" x1="32.9009" y1="74" x2="42.2753" y2="51.9933" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint12_linear_15481_6038" x1="121.086" y1="55" x2="121.086" y2="93" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint13_linear_15481_6038" x1="127.425" y1="55" x2="127.425" y2="91.8255" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint14_linear_15481_6038" x1="133" y1="105" x2="149.274" y2="98.7097" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint15_linear_15481_6038" x1="12" y1="98" x2="16.5924" y2="97.3787" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint16_linear_15481_6038" x1="114" y1="98" x2="118.643" y2="97.6074" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint17_linear_15481_6038" x1="5.77332" y1="94" x2="26.8158" y2="83.2714" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D7B0A"/>
<stop offset="1" stop-color="#B0B447"/>
</linearGradient>
<linearGradient id="paint18_linear_15481_6038" x1="103.918" y1="94.1537" x2="127.236" y2="88.682" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D7B0A"/>
<stop offset="1" stop-color="#B0B447"/>
</linearGradient>
<linearGradient id="paint19_linear_15481_6038" x1="115.691" y1="103.661" x2="147.146" y2="98.3885" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint20_linear_15481_6038" x1="139.106" y1="80.2455" x2="143.932" y2="79.4296" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint21_linear_15481_6038" x1="131" y1="81" x2="135.546" y2="80.2312" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint22_linear_15481_6038" x1="132" y1="80" x2="134.273" y2="79.6156" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint23_linear_15481_6038" x1="124" y1="80" x2="130.82" y2="78.8468" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint24_linear_15481_6038" x1="125" y1="79" x2="129.546" y2="78.2312" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint25_linear_15481_6038" x1="13" y1="101" x2="70.7032" y2="53.3598" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint26_linear_15481_6038" x1="1" y1="107" x2="3.25847" y2="106.926" gradientUnits="userSpaceOnUse">
<stop stop-color="#D97D0E"/>
<stop offset="1" stop-color="#FFE352"/>
</linearGradient>
<linearGradient id="paint27_linear_15481_6038" x1="2" y1="107" x2="7.78093" y2="106.389" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint28_linear_15481_6038" x1="5" y1="108" x2="30.0303" y2="49.5896" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint29_linear_15481_6038" x1="81" y1="101" x2="81.0703" y2="105.675" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint30_linear_15481_6038" x1="26" y1="108" x2="92.9178" y2="60.5949" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint31_linear_15481_6038" x1="29" y1="126" x2="56.2784" y2="121.387" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint32_linear_15481_6038" x1="34.6929" y1="120.307" x2="49.0298" y2="117.882" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint33_linear_15481_6038" x1="41.9341" y1="107.693" x2="41.9341" y2="118.438" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint34_linear_15481_6038" x1="55" y1="126" x2="82.2784" y2="121.387" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint35_linear_15481_6038" x1="60.6929" y1="120.307" x2="75.0298" y2="117.882" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint36_linear_15481_6038" x1="68" y1="108" x2="68" y2="118" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint37_linear_15481_6038" x1="115" y1="126" x2="126.366" y2="124.078" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint38_linear_15481_6038" x1="117.372" y1="123.628" x2="123.346" y2="122.618" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint39_linear_15481_6038" x1="113.25" y1="118.224" x2="125.46" y2="111.628" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint40_linear_15481_6038" x1="118" y1="122" x2="122.666" y2="121.775" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint41_linear_15481_6038" x1="17" y1="112" x2="85.4145" y2="78.5364" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B86CB"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
</defs>
</svg>
